import styled from 'styled-components';

export const InfoPageTableCol = styled.col`
  width: ${({ width }) => width || '50%'};
`;
